import { render } from "./AppHeaderUserButton.vue?vue&type=template&id=10611fee&scoped=true"
import script from "./AppHeaderUserButton.vue?vue&type=script&lang=js"
export * from "./AppHeaderUserButton.vue?vue&type=script&lang=js"

import "./AppHeaderUserButton.vue?vue&type=style&index=0&id=10611fee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10611fee"]])

export default __exports__